export let perfil: any = {
  usuario:
  {
    id_user: "",
    nombre: "",
    ap_paterno: "",
    ap_materno: "",
    email: "",
    idUserRefer: ""
  },
  permisos:
  {
    MaestroSocios: { edicion: false, consulta: false, reportes: false, borrar: false },
    MantPrecioCompo: { edicion: false, consulta: false, reportes: false, borrar: false },
    PrecioPromSem: { edicion: false, consulta: false, reportes: false, borrar: false },
    PrecioFijoSem: { edicion: false, consulta: false, reportes: false, borrar: false },
    PrecioFijoVig: { edicion: false, consulta: false, reportes: false, borrar: false },
    MantAcciones: { edicion: false, consulta: false, reportes: false, borrar: false },
    MantContratos: { edicion: false, consulta: false, reportes: false, borrar: false },
    MantLitrosAcciones: { edicion: false, consulta: false, reportes: false, borrar: false },
    TopesDia: { edicion: false, consulta: false, reportes: false, borrar: false },
    TopesSemana: { edicion: false, consulta: false, reportes: false, borrar: false },
    FormulasCalidad: { edicion: false, consulta: false, reportes: false, borrar: false },
    Bancos: { edicion: false, consulta: false, reportes: false, borrar: false },
    Rutas: { edicion: false, consulta: false, reportes: false, borrar: false },
    Sucursales: { edicion: false, consulta: false, reportes: false, borrar: false },
    Tanques: { edicion: false, consulta: false, reportes: false, borrar: false },
    Veterinarios: { edicion: false, consulta: false, reportes: false, borrar: false },
    Plantas: { edicion: false, consulta: false, reportes: false, borrar: false },
    TipoDesvios: { edicion: false, consulta: false, reportes: false, borrar: false },
    RelPago: { edicion: false, consulta: false, reportes: false, borrar: false },
    Conceptos: { edicion: false, consulta: false, reportes: false, borrar: false },
    ControlConcepCia: { edicion: false, consulta: false, reportes: false, borrar: false },
    CompTransportistas: { edicion: false, consulta: false, reportes: false, borrar: false },
    MovRecoleccion: { edicion: false, consulta: false, reportes: false, borrar: false },
    AgrupRutasMovRecol: { edicion: false, consulta: false, reportes: false, borrar: false },
    ConcFactSocios: { edicion: false, consulta: false, reportes: false, borrar: false },
    GrupAparcerias: { edicion: false, consulta: false, reportes: false, borrar: false },
    RegionesRecol: { edicion: false, consulta: false, reportes: false, borrar: false },
    GrupArrendamientos: { edicion: false, consulta: false, reportes: false, borrar: false },
    ContSirla: { edicion: false, consulta: false, reportes: false, borrar: false },
    TablaCompensacionLog: { edicion: false, consulta: false, reportes: false, borrar: false },
    MantClaseA: { edicion: false, consulta: false, reportes: false, borrar: false },
    Capturas: { edicion: false, consulta: false, reportes: false, borrar: false },
    Reportes: { edicion: false, consulta: false, reportes: false, borrar: false },
    AnLecheTanque: { edicion: false, consulta: false, reportes: false, borrar: false },
    Procesos: { edicion: false, consulta: false, reportes: false, borrar: false },
    CargaMilkoScan: { edicion: false, consulta: false, reportes: false, borrar: false },
    CargaColLPC: { edicion: false, consulta: false, reportes: false, borrar: false },
    Consultas: { edicion: false, consulta: false, reportes: false, borrar: false },
    DirSocios: { edicion: false, consulta: false, reportes: false, borrar: false },
    Deducciones: { edicion: false, consulta: false, reportes: false, borrar: false },
    Contabilidad: { edicion: false, consulta: false, reportes: false, borrar: false },
    ProcCrioscopia: { edicion: false, consulta: false, reportes: false, borrar: false },
    Accesos: { edicion: false, consulta: false, reportes: false, borrar: false },
    Usuarios: { edicion: false, consulta: false, reportes: false, borrar: false },
    Perfiles: { edicion: false, consulta: false, reportes: false, borrar: false },
    JuegoVal: { edicion: false, consulta: false, reportes: false, borrar: false },
    Regiones: { edicion: false, consulta: false, reportes: false, borrar: false }
  }
};

export let perfilUsarAccesoDe: any = {
  permisos:
  {
    MaestroSocios: { edicion: false, consulta: false, reportes: false, borrar: false },
    MantPrecioCompo: { edicion: false, consulta: false, reportes: false, borrar: false },
    PrecioPromSem: { edicion: false, consulta: false, reportes: false, borrar: false },
    PrecioFijoSem: { edicion: false, consulta: false, reportes: false, borrar: false },
    PrecioFijoVig: { edicion: false, consulta: false, reportes: false, borrar: false },
    MantAcciones: { edicion: false, consulta: false, reportes: false, borrar: false },
    MantContratos: { edicion: false, consulta: false, reportes: false, borrar: false },
    MantLitrosAcciones: { edicion: false, consulta: false, reportes: false, borrar: false },
    TopesDia: { edicion: false, consulta: false, reportes: false, borrar: false },
    TopesSemana: { edicion: false, consulta: false, reportes: false, borrar: false },
    FormulasCalidad: { edicion: false, consulta: false, reportes: false, borrar: false },
    Bancos: { edicion: false, consulta: false, reportes: false, borrar: false },
    Rutas: { edicion: false, consulta: false, reportes: false, borrar: false },
    Sucursales: { edicion: false, consulta: false, reportes: false, borrar: false },
    Tanques: { edicion: false, consulta: false, reportes: false, borrar: false },
    Veterinarios: { edicion: false, consulta: false, reportes: false, borrar: false },
    Plantas: { edicion: false, consulta: false, reportes: false, borrar: false },
    TipoDesvios: { edicion: false, consulta: false, reportes: false, borrar: false },
    RelPago: { edicion: false, consulta: false, reportes: false, borrar: false },
    Conceptos: { edicion: false, consulta: false, reportes: false, borrar: false },
    ControlConcepCia: { edicion: false, consulta: false, reportes: false, borrar: false },
    CompTransportistas: { edicion: false, consulta: false, reportes: false, borrar: false },
    MovRecoleccion: { edicion: false, consulta: false, reportes: false, borrar: false },
    AgrupRutasMovRecol: { edicion: false, consulta: false, reportes: false, borrar: false },
    ConcFactSocios: { edicion: false, consulta: false, reportes: false, borrar: false },
    GrupAparcerias: { edicion: false, consulta: false, reportes: false, borrar: false },
    RegionesRecol: { edicion: false, consulta: false, reportes: false, borrar: false },
    GrupArrendamientos: { edicion: false, consulta: false, reportes: false, borrar: false },
    ContSirla: { edicion: false, consulta: false, reportes: false, borrar: false },
    TablaCompensacionLog: { edicion: false, consulta: false, reportes: false, borrar: false },
    MantClaseA: { edicion: false, consulta: false, reportes: false, borrar: false },
    Capturas: { edicion: false, consulta: false, reportes: false, borrar: false },
    Reportes: { edicion: false, consulta: false, reportes: false, borrar: false },
    AnLecheTanque: { edicion: false, consulta: false, reportes: false, borrar: false },
    Procesos: { edicion: false, consulta: false, reportes: false, borrar: false },
    CargaMilkoScan: { edicion: false, consulta: false, reportes: false, borrar: false },
    CargaColLPC: { edicion: false, consulta: false, reportes: false, borrar: false },
    Consultas: { edicion: false, consulta: false, reportes: false, borrar: false },
    DirSocios: { edicion: false, consulta: false, reportes: false, borrar: false },
    Deducciones: { edicion: false, consulta: false, reportes: false, borrar: false },
    Contabilidad: { edicion: false, consulta: false, reportes: false, borrar: false },
    ProcCrioscopia: { edicion: false, consulta: false, reportes: false, borrar: false },
    Accesos: { edicion: false, consulta: false, reportes: false, borrar: false },
    Usuarios: { edicion: false, consulta: false, reportes: false, borrar: false },
    Perfiles: { edicion: false, consulta: false, reportes: false, borrar: false },
    JuegoVal: { edicion: false, consulta: false, reportes: false, borrar: false },
    Regiones: { edicion: false, consulta: false, reportes: false, borrar: false }
  }
};